<div class="fade yellow-card rounded-4 mb-10 relative">
  <div class="mb-10 mobile-view">
    <a class="absolute close" (click)="close()">
      <i class="fa-sharp fa-solid fa-xmark fa-xl"></i>
    </a>
    <div class="bold">
      Contact Information
    </div>
    <ul class="info pb-10 mb-10">
      <li>
        <div>
          Email
        </div>
        <div class="bold">
          {{request().rolesRequested[0].email}}
        </div>
      </li>
      <li>
        <div>
          Phone
        </div>
        <div class="bold">
          {{getFormattedPhoneNum(request().rolesRequested[0].areaCode + request().rolesRequested[0].phone)}}
        </div>
      </li>
      <li>
        <div>
          Address
        </div>
        <div class="bold">
          {{request().address?.addressI}} {{request().address?.addressII}} {{request().address?.city}} {{request().address?.state?.name}} {{request().address?.zipCode}}
        </div>
      </li>
    </ul>
  </div>
  <div class="width-full">
    <div>
      <div class="mtb-10">
        <b>Current Roles</b>
      </div>
    </div>
    <div>
      <ul class="roles">
        @for (roleName of request().existingRoles; track roleName) {
          <li>
            {{roleName}}
          </li>
        }
      </ul>
    </div>
  </div>
</div>